import { error } from 'jquery';
import { ON_FAIL_SEARCH_RECOMMENDATIONS_BY_EMAIL, ON_FAIL_SEARCH_RECOMMENDATIONS_BY_FEE, ON_FAIL_SEARCH_RECOMMENDATIONS_BY_RUC } from '../../types/searchRecommendationsTypes';
import buildFlightSegment from './buildFlightSegment';

const getSearchRecommendationRQ = (params, travelItineraryRS) => {
    if(params.email.trim() === "") {
        return {error: ON_FAIL_SEARCH_RECOMMENDATIONS_BY_EMAIL};
    }
    if(params.hasRUC && params.ruc.trim() === "") {
        return {error: ON_FAIL_SEARCH_RECOMMENDATIONS_BY_RUC}
    }
    if(params.hasFEE && (params.feeAmount === 0 || params.feeAmount.trim() === "")) {
        return { error: ON_FAIL_SEARCH_RECOMMENDATIONS_BY_FEE}
    }
    let originDestinationsOption = [];

    const odOptions = travelItineraryRS.airItinerary.originDestinationOptions.originDestinationOption;
    const firstSegment = odOptions[0].flightSegment[0];

    const airline = firstSegment.operatingAirline.code;
    const originRph = firstSegment.rph;
    const resBookDesigCode = firstSegment.resBookDesigCode;
 
    const returnRph = odOptions[odOptions.length - 1].flightSegment[0].rph;//odOptions[1]?.flightSegment[0]?.rph || "";
    switch (params.flightTypeOption) {
        case "OW": // Solo ida
            originDestinationsOption.push({
                flightSegment: buildFlightSegment(
                    params.origin,
                    params.destination,
                    params.startDate,
                    airline,
                    originRph,
                    resBookDesigCode
                ),
                travelPurpose: "CHANGE"
            });
            break;

        case "OR": // Solo regreso
            originDestinationsOption.push({
                flightSegment: buildFlightSegment(
                    params.origin,       // no se invierte
                    params.destination,  // se respeta lo ingresado
                    params.startDate,
                    airline,
                    returnRph,
                    resBookDesigCode
                ),
                travelPurpose: "CHANGE"
            });
            break;

        case "RT": // Ida y vuelta
            originDestinationsOption.push(
                // Ida
                {
                    flightSegment: buildFlightSegment(
                        params.origin,
                        params.destination,
                        params.startDate,
                        airline,
                        originRph,
                        resBookDesigCode
                    ),
                    travelPurpose: "CHANGE"
                },
                // Vuelta
                {
                    flightSegment: buildFlightSegment(
                        params.destination, // aquí sí se invierte
                        params.origin,
                        params.endDate,
                        airline,
                        returnRph
                    ),
                    travelPurpose: "CHANGE"
                }
            );
            break;
    }
    

    let airTravelerAvails = [];
    travelItineraryRS.travelerInfo.airTraveler.forEach( traveler => {
        
        let ticketNumber = "";
        travelItineraryRS.ticketing.forEach(ticket => {
            if (ticket.travelerRefNumber[0] === traveler.travelerRefNumber.rph)
                ticketNumber = ticket.ticketDocumentNbr;
        });
        let document = `D${traveler.document[0].docID}`;
        let airTravelerAvail = {
            "passengerTypeQuantity": [],
            "airTraveler": {
                "personName": traveler.personName,
                "telephone": [],
                "email": [],
                "address": [],
                "custLoyalty": [],
                "document": [{ "docLimitations": [], "docID": document }],
                "travelerRefNumber": { 
                    "rph": traveler.travelerRefNumber.rph,
                    "surnameRefNumber": ticketNumber
                },
                "socialMediaInfo": [],
            }
        };
        airTravelerAvails.push(airTravelerAvail);
    });

    return {
        "pos": { "source": [{ "pseudoCityCode": travelItineraryRS.ticketing[0].pseudoCityCode, "erspuserID": travelItineraryRS.ticketing[0].pricingSystem.code, 
            "agentDutyCode": params.email}] }, // ingresar aqui el gd
        "airItinerary": {
            "originDestinationOptions": {
                "originDestinationOption": originDestinationsOption
            }
        },
        "travelerInfoSummary": {
            "seatsRequested": [],
            "airTravelerAvail": airTravelerAvails,
            "pricingPref": [],
            "paymentDetailType": {
                "paymentAmount": {
                    "amount": params.feeAmount
                }
            }
        },
        "bookingReferenceID": { "id": travelItineraryRS.pnr, "idcontext": travelItineraryRS.orderId, "companyName": { "value": params.ruc }, "type": params.flightTypeOption },
        "flightReference": []
    }
};

export default getSearchRecommendationRQ;